import { useEffect, useState } from "react";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";
import { LazyImage } from "../../../Services/Decorator_Lazy_Loading/ImageVideoLazyLoding";
import { Dropdown } from "primereact/dropdown";

const MessageContact = ({ currentPage, employeeId }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [selectedEmployees, setSelectedEmployees] = useState(null);
  const [newMembers, setNewMembers] = useState([]);

  useEffect(() => {
    fetchEmployeeIdData();
  }, []);

  useEffect(() => {
    if (selectedEmployees) {
      employeeId = selectedEmployees;
      currentPage("contactType", employeeId);
    }
  }, [selectedEmployees]);

  const changePageType = () => {
    currentPage("contactType");
  };

  async function fetchEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000,
      EmployeeId: 0,
             IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let empData = employeesList?.Data?.filter((item) => item.Id !== userDetails.EmpId);
      setNewMembers(empData);
    } catch (error) {}
  }

  const employeeOptionTemplate = (option) => {
      return (
        <div className="flex align-items-center gap-2 ticket-file-attach__items_detail">
          <LazyImage alt={option?.FullName} src={option?.ProfileImage} width="32" />
          <span>{option?.FullName}{option?.UserName?.length > 0 && ','}</span><span>{option?.UserName}{option?.CurrentDesignation?.length > 0 && ','}</span><span>{option?.CurrentDesignation}</span>
        </div>
      );
    };

  return (
    <>
      <div className="col-md-9 pl-0">
        <div className="tab-content" id="v-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="v-pills-home"
            role="tabpanel"
            aria-labelledby="v-pills-home-tab"
            tabIndex={0}
          >
            <div className="create-new-wrap">
              <div className="top-headingtitile">
                <h3>Start New Conversation</h3>
                <div className="grp-info">
                  <a onClick={() => changePageType()}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      fill="currentColor"
                      className="bi bi-arrow-left"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                      />
                    </svg>
                  </a>
                </div>
              </div>
              <div className="addnew-form" style={{ padding: "3rem" }}>
                <form>
                  <div className="row justify-content-center">
                    <div className="col-md-8">
                      <div className="col-md-12">
                        <div className="innerform-grp">
                          <label className="form-label mb-2">
                            Look for people
                          </label>
                          <Dropdown
                            value={selectedEmployees}
                            onChange={(e) => {setSelectedEmployees(e.value)}}
                            options={newMembers}
                            filter={true}
                            optionLabel="FullName"
                            placeholder="Choose for Start New Conversation"
                            maxSelectedLabels={1}
                            itemTemplate={employeeOptionTemplate}
                            name="EmpId"
                            className="w-100 md:w-20rem p-0 h-40 line-height-40 custom-multiselect leaveforteam"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MessageContact;
